module.exports = __webpack_public_path__ + "img/hongdoumizao.d4ee91ca.jpg";